routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.myPaymentsList', {
      url: "mis-pagos/listado",
      template: `<my-payments-list sh-ctrl="shCtrl"></my-payments-list>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/my-payments/my-payments-list/my-payments-list.config.js
 **/